const headers = {
  name: "Users",
  navigate: {
    tabs: [
      {
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Users",
        path: "/app/settings/users",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
